import { render } from "./SummaryBox3.vue?vue&type=template&id=64d02684&scoped=true"
import script from "./SummaryBox3.vue?vue&type=script&lang=js"
export * from "./SummaryBox3.vue?vue&type=script&lang=js"

import "./SummaryBox3.vue?vue&type=style&index=0&id=64d02684&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d02684"]])

export default __exports__